module.exports = __webpack_public_path__ + "img/plug-right-mobile.ec19ce3f.png";